export default "__VITE_ASSET__B83efC02__"